export const defaultDataEvent = (teamOfInterest) => ({
  [teamOfInterest ? ('data:' + teamOfInterest): 'data']: {
    highlights: {},
    zones:{},
    players: [],
    playersBall: [],
    manage: {},
    practiceViewer: {}
  },
  modalPlayers: {},
  modalBallMetrics: {},
  mongoId: '',
  alerts: {}
});

export const defaultVenues = {
  ncaaFbs: {
    practice: [],
    game: []
  },
  nfl: {
    practice: [],
    game: []
  },
  mlax: {
    practice: []
  }
};

export const defaultSearchesProperties = {
  playersData: [],
  playersCombineData:{}
};


export const defaultPlayers = {
  players: {},
};

export const defaultFlags = {
  scheduleFetch: true,
  liveFetch: true,
  dataOpsFetch: true,
  download: false,
};

export const defaultPracticeView = {
  dimensions: [],
  blinks: [],
  practiceData: {}
};

export const defaultAbout = {
  announcements: '',
  documents: [],
  weeklyLeaderBoards: []
};

export const defaultEntities = {
  entities: {},
  byTeam: true
};
